"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var web3_shim_1 = require("./web3-shim");
exports.Web3Shim = web3_shim_1.Web3Shim;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/truffle-interface-adapter/dist/index.js
// module id = +2hC
// module chunks = 0